import { createFocusOutlineStyle, makeStyles, tokens } from '@fluentui/react-components';

export const usePolicyBreadcrumbStyles = makeStyles({
    list: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        listStyleType: 'none',
        margin: 0,
        padding: 0,
        fontSize: tokens.fontSizeBase200,
        // AppLayout drops its page padding at this breakpoint (incl. 400% zoom), leaving the breadcrumb
        // flush against a scroll container that would clip the top/left of the focus outline.
        '@media (max-width: 768px)': {
            padding: '4px',
        },
    },
    item: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
    },
    // Fluent's Link marks keyboard focus with only a (double) underline. Draw a full focus ring the way
    // Fluent buttons do: a bordered ::after box. A plain `outline` can't be used because Link's own
    // `:focus-visible { outline-style: none }` lands in a later Griffel bucket and wins.
    link: {
        position: 'relative',
        ...createFocusOutlineStyle({
            style: { outlineOffset: '2px', outlineRadius: tokens.borderRadiusSmall },
        }),
    },
    homeLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        fontSize: tokens.fontSizeBase200,
    },
    separator: {
        color: tokens.colorNeutralForeground3,
    },
    current: {
        color: tokens.colorNeutralForeground2,
    },
});
